import { render, staticRenderFns } from "./KFormModelItem.vue?vue&type=template&id=0aafe139&"
import script from "./KFormModelItem.vue?vue&type=script&lang=js&"
export * from "./KFormModelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports